/**
 * @desc This is to make api call before user clicks on search button
 * @author Mahipatsinh Jadav
 * When user select city - make call to hotel-content and city-images
 * when user select date or traveller info make call to scData and sid-results api
 */

!function(name, module, context){
	if(window.define) define('hotelBackgroundSearch',[], module)
	else context[name] = module()
}('hotelBackgroundSearch', function(){
    var hotelBackgroundSearch = {
        hotels: {}, //Object to content api(hotel-content, city-images, scData, sid-results) response 
        makeAjaxCall: function(options,callback) {
            var self = this;
            $.ajax({
                url : options.url,
                type: "GET",
            }).done(function(data){
                self.set(options.key, data);
                callback && callback(data);
            }).fail(function(error){
                
            })
        },
        //hotel-content api call
		getHotelContent: function(options) {
            var url = "/hotels/jsonservice/hotel-content?city="+ options.city +"&country="+ options.country +"&state=";
            url += options.state || '';
            var self = this;
            $("#SearchHotelsButton").val("Search hotels");
            this.makeAjaxCall({
                url: url,
                key: "content"
            },function(){
                self.getScData();
            });
        },
        //scData api call - to get hotel rank
        getScData: function() {
            var self = this;
            var searchFormData = _.deserialize($("#SearchForm").serialize());
            if(searchFormData.city != "" && searchFormData["chk_in"] != '' &&  searchFormData["chk_out"] != ''){
                //If user directly come on SRP and changed date then hotel content will be empty so get hotel content also.
                if(!self.get("content")){
                    self.getHotelContent({city:searchFormData.city, state:searchFormData.state, country:searchFormData.country});
                    self.getCityImages({city:searchFormData.city, state:searchFormData.state, country:searchFormData.country});
                }
                
                var queryString = _.serialize(searchFormData);
                queryString += "&lowRate=true&all-hotels=true";
                queryString += "&pahCCRequired=true";
                var url = "/hotels/service/scData?" + queryString;
                self.remove("scData");
                self.remove("sidResults");
                self.makeAjaxCall({
                    url: url,
                    key: "scData"
                },function(){
                    //Expire rates data after 1 min
                    setTimeout(function(){
                        self.remove("scData");
                        self.remove("sidResults");
                    },60000)
                    self.getSidResults();
                });
            } else {
                self.remove("scData");
                self.remove("sidResults");
            }
        },
        //this is to get rate of each hotel
        getSidResults: function() {
            var sid = this.get("scData").sid;
            var url = "/hotels/service/sid-results?index=1&count=1&sid=" + sid;
            var self = this;
            this.makeAjaxCall({
                url: url,
                key: "sidResults"
            }, function(response){
                if(response.retry || response.progress){
                    self.remove("sidResults");
                } 
                if(response.results && response.results.ht){
                    if($.isEmptyObject(response.results.ht)){
                        self.remove("sidResults");
                    } else {
                        $("#SearchHotelsButton").val("Show hotels ("+ self.get("content").ht.length +")");   
                    }
                }
            });
        },
        //Get images list fo each hotels
        getCityImages: function(options) {
            var url = "/hotels/jsonservice/city-images?city="+ options.city +"&country="+ options.country +"&state=";
            url += options.state || '';
            this.makeAjaxCall({
                url: url,
                key: "images"
            });
        },
        //Remove supplied key from the hotel object
        remove: function(key){
            return this.hotels[key] = null;
        },
        //Return supplied key as response
        get: function(key){
            return this.hotels[key];
        },
        //Set supplied key and value to hotels object
        set: function(key, value){
            this.hotels[key] = value;
        }
    }
    //Do not make call to same api again if something change in 400 ms
    hotelBackgroundSearch.getScData = _.debounce(hotelBackgroundSearch.getScData, 300);
    return hotelBackgroundSearch;
}, CT)
;
